"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberSelectionPanel = void 0;
var DeviceCard_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/DeviceCard.cms");
var PPUAddressCarrierInfoModal_cms_1 = require("../components/cards/PPUAddressCarrierInfoModal/PPUAddressCarrierInfoModal.cms");
var FormOptions_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/FormOptions/FormOptions.cms");
// tslint:disable-next-line:max-line-length
var AssignForm_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/AssignForm/AssignForm.cms");
// tslint:disable-next-line:max-line-length
var EligibilityNotification_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/TransferForm/EligibilityNotification/EligibilityNotification.cms");
// tslint:disable-next-line:max-line-length
var AreaCodeSelector_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/AssignForm/AreaCodeSelector/AreaCodeSelector.cms");
// tslint:disable-next-line:max-line-length
var CareerInfo_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/TransferForm/CareerInfo/CareerInfo.cms");
// tslint:disable-next-line:max-line-length
var CareerInfoRenderer_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/TransferForm/CareerInfoRenderer/CareerInfoRenderer.cms");
// tslint:disable-next-line:max-line-length
var TransferForm_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/TransferForm/TransferForm.cms");
var ExpandedFormOptions_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/ExpandedFormOptions.cms");
var DeviceOptions_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceOptions/DeviceOptions.cms");
var AccountHolderInfo_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/AccountHolderInfo/AccountHolderInfo.cms");
var TabRenderer_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/FormOptions/TabRenderer/TabRenderer.cms");
var PhoneDetails_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/PhoneDetails/PhoneDetails.cms");
// tslint:disable-next-line:max-line-length
var CheckNumbersRenderer_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/TransferForm/CheckedNumbersRenderer/CheckNumbersRenderer.cms");
var PpuAddress_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/PpuAddress/PpuAddress.cms");
var NumberSelectionPanel = /** @class */ (function () {
    function NumberSelectionPanel() {
        this.LOSGNumberSelection = new DeviceCard_cms_1.DeviceCardCms();
        this.pPUAddressCarrierInfoModal = new PPUAddressCarrierInfoModal_cms_1.PPUAddressCarrierInfoModalCms();
        this.ppuAddress = new PpuAddress_cms_1.PpuAddressCms();
        this.formOptions = new FormOptions_cms_1.FormOptionsCms();
        this.assignFormLnp = new AssignForm_cms_1.AssignFormCms();
        this.eligibilityNotification = new EligibilityNotification_cms_1.EligibilityNotificationCms();
        this.areaCodeSelectorLnp = new AreaCodeSelector_cms_1.AreaCodeSelectorCms();
        this.careerInfoCmsLnp = new CareerInfo_cms_1.CareerInfoCms();
        this.careerInfoRendererLnp = new CareerInfoRenderer_cms_1.CareerInfoRendererCms();
        this.transferFormCmsLnp = new TransferForm_cms_1.TransferFormCms();
        this.expandedFormOptionsLnp = new ExpandedFormOptions_cms_1.ExpandedFormOptionsCms();
        this.deviceOptionsLnp = new DeviceOptions_cms_1.DeviceOptionsCms();
        this.accountHolderInfoLnp = new AccountHolderInfo_cms_1.AccountHolderInfoCms();
        this.tabRendererCmsLnp = new TabRenderer_cms_1.TabRendererCms();
        this.phoneDetailsCmsLnp = new PhoneDetails_cms_1.PhoneDetailsCms();
        this.checkNumbersRendererLnp = new CheckNumbersRenderer_cms_1.CheckNumbersRendererCms();
    }
    return NumberSelectionPanel;
}());
exports.NumberSelectionPanel = NumberSelectionPanel;
//# sourceMappingURL=NumberSelectionPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/cms/NumberSelectionPanel.cms.js
// module id = 1999
// module chunks = 8